import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ti',
    fullName: 'Tigrinya',
    nativeName: 'ትግርኛ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ኣርግቮይድ",
    landing_title: "ገለ ዘገርም ነገር ይመጽእ ኣሎ።",
    landing_subtitle: "ኣርግቮይድ ናይ ኣፕን ጸወታን ምምዕባል ስቱድዮ እዩ። ተኸታተሉ፣ ሓደሽቲ ነገራት ኣብ ቀረባ እዋን!",
    select_language: "ቋንቋ ምረጽ",
    search_placeholder: "ቋንቋታት ድለዩ...",
    terms_title: "ውዕል ኣገልግሎት",
    policy_title: "ፖሊሲ ውልቃዊ ሓበሬታ",
    cookies_title: "ፖሊሲ ኩኪስ",
    terms_content: `
        <strong>1. ምቕባል ውዕላት</strong><br>
        ናብ ArgVoid ብምእታው፡ እዚ ውዕላት ኣገልግሎት ተቐባልነት ኣለዎ። እዞም ውዕላት እዚኦም እንተዘይተሰማሚዖም እቲ ኣገልግሎት ኣብ ጥቕሚ ክውዕል የብሉን።<br><br>

        <strong>2. ኣጠቓቕማ መድረኽ</strong><br>
        ኣርግቮይድን መተግበሪታቱን ንሓበሬታውን ፈጠራውን ዕላማታት "ከምዘለዎ" ይቐርቡ። እቲ ኣገልግሎት ንሕጋዊ ዕላማታት ጥራይ ክውዕል ኣለዎ።<br><br>

        <strong>3. ዝተኸልከለ ኣካይዳ</strong><br>
        ንናይ ሳይት ተቓላዕነት ምምዝማዝ፣ ስፓሚንግ፣ ወይ ድማ ብዘይፍቓድ ናብቲ ትሕተ ቅርጺ ምእታው ምፍታን ብጥብቂ ክልኩል እዩ።<br><br>

        <strong>4. ሓላፍነት ምውሳድ</strong><br>
        እቲ መድረኽን ኣገልግሎታትን ኣብ ዝኾነ እዋን ብዘይ ምፍላጥ ክቕየር ይኽእል እዩ። ብዛዕባ ስራሕ ወይ ምህላው እቲ ኣገልግሎት ዝኾነ ዋሕስ ኣይወሃብን እዩ።
    `,
    policy_content: `
        <strong>1. ምእካብ ሓበሬታ</strong><br>
        እቲ መድረኽ ኣብዚ እዋን እዚ ናይ ተጠቃሚ ምርግጋጽ ወይ ምፍጣር ኣካውንት ኣየድልዮን እዩ። ዝኾነ ውልቃዊ መለለዪ ሓበሬታ (ከም ኣስማት ወይ ኢመይል ኣድራሻታት) ካብ በጻሕቲ ብንጥፈት ኣይእከብን እዩ።<br><br>

        <strong>2. ኣጠቓቕማ ዳታ</strong><br>
        መሰረታዊ፡ ስሙ ዘይተገልጸ ትንታነታት ትራፊክ ሳይት ንምርዳእን ነቶም ኣፕሊኬሽናት ንምምሕያሽን ክእከቡ ይኽእሉ። እዚ ዳታ ምስ ውልቃዊ መንነት ተጠቃሚ ዝተኣሳሰር ኣይኮነን።<br><br>

        <strong>3. ኣገልግሎት ሳልሳይ ወገን</strong><br>
        ሳልሳይ ወገን ወሃብቲ ኣገልግሎት ንኣገልግሎት ምእንጋድን ትንተናን ክጥቀሙ ይኽእሉ። ናይዞም በብወገኖም ወሃብቲ ኣገልግሎት ብሕታዊነት ነቲ ኣብ ትሕተ ቅርጾም ዝስራሕ ስሙ ዘይተገልጸ ዳታ ይገዝእዎ።<br><br>

        <strong>4. ድሕነት ዳታ</strong><br>
        ነቲ መድረኽ ንምሕላው ርትዓዊ ስጉምትታት ጸጥታ ይትግበር። ይኹን እምበር ዝኾነ ይኹን ኣገባብ ምትሕልላፍ ብኢንተርነት ምሉእ ብምሉእ ውሑስ ኣይኮነን።<br><br>
    `,
    cookies_content: `
        <strong>1. ኩኪስን ከባብያዊ መኽዘንን እንታይ እዮም?</strong><br>
        ኩኪስን ናይ መርበብ ሓበሬታ ከባብያዊ መኽዘንን ኣብ መላእ ምብጻሕ ንዝግበር ምርጫታት ውቅር ንምዝካር ኣብቲ መሳርሒ ዝኽዘኑ ንኣሽቱ ፋይላት ዳታ እዮም።<br><br>

        <strong>2. ዕላማ ኣጠቓቕማ</strong><br>
        Browser LocalStorage ንናይ ውቅር ቅጥዕታት ንምዕቃብ ብጥብቂ ይጥቀመሉ፣ ከም:<br>
        - ምርጫታት ቋንቋ<br>
        - ውቅር መተሓላለፊ ተጠቃሚ (ንኣብነት፡ ቅጥዕታት ኣቀማምጣ ወይ ቴማ)<br>
        - ግዝያዊ መተግበሪ cache<br><br>

        <strong>3. ምክትታል የለን</strong><br>
        ኩኪስን ናይ ከባቢ መኽዘንን ንመወዓውዒ ወይ ንዕላማታት ምክትታል ሳልሳይ ወገን ኣይጥቀሙን እዮም። ኩሉ ዝተዓቀበ ዳታ ብጥብቂ ንቐንዲ ተግባር ናይቲ መድረኽ እዩ።<br><br> እዩ።

        <strong>4. ቁጽጽር</strong><br>
        ዳታ መርበብ ሓበሬታ ኣብ ዝኾነ እዋን ብመንገዲ ቅጥዕታት መርበብ ሓበሬታ ክጽረግ ይኽእል እዩ፣ እዚ ድማ ዝኾነ ውሽጣዊ ውቅርታት ዳግማይ ክሰርዖ እዩ።
    `,
    cookie_consent_text: "እቲ መርበብ ሓበሬታ ብትኽክል ከም ዝሰርሕ ንምርግጋጽ መሰረታዊ ኩኪስ ንጥቀም፣ ከም ክፍለ ግዜኻ ንጡፍ ምግባር፣ ምርጫ ቋንቋኻ ምዕቃብን ካልእ ብሕታዊ ውቅርታትን።",
    read_policy: "ፖሊሲ ኩኪ ኣንብብ",
    support_title: "ንደገፍ ርክብ ግበሩ",
    support_subject_label: "ዋና",
    support_message_label: "መልእኽቲ",
    support_submit_button: "መልእኽቲ ስደዱ",
    support_hint: "መተሓሳሰቢ፡ እዚ ነቲ መልእኽቲ ንምልኣኽ ነባሪ ናይ ኢመይል መተግበሪኻ ክኸፍት እዩ።",
    support_success_msg: "ናይ ኢመይል ኣፕካ ምኽፋት...",
    support_error_msg: "መልእኽቲ ምልኣኽ ኣይከኣለን። በጃኹም ድሒርኩም ደጊምኩም ፈትኑ።",
    explorer_title: "ኤክስፕሎረር",
    history_title: "ታሪኽ",
    animation_title: "ኣኒሜሽን",
    config_title: "ውቅር",
    tool_mouse: "(Ctrl+M) ምረጽ።",
    tool_brush: "ብራሽ (Ctrl+B)",
    tool_brush_mode: "ሞድ ምቕያር (ጽኑዕ/ንጹር)",
    tool_eraser: "መደምሰሲ (Ctrl+E)",
    tool_brush_size: "ዓቐን ብራሽ ኣስተኻኽል",
    tool_bucket: "ምልኣዮ (Ctrl+F)",
    tool_eyedropper: "ናይ ዓይኒ ንጣብ",
    tool_grid: "ሽቦ (Ctrl+Shift+B)",
    tool_rotate: "ምዝዋር (Ctrl+Shift+R)",
    tool_flip_h: "ፍሊፕ ኤች (Ctrl+Shift+H)",
    tool_flip_v: "ፍሊፕ V (Ctrl+Shift+V) ዝብል ጽሑፍ ኣሎ።",
    tool_transpose: "ትራንስፖዝ (Ctrl+Shift+T) ምግባር።",
    label_width: "ስፍሓት",
    label_height: "ቁመት",
    label_frames: "ብዝሒ ፍሬማት",
    label_animation: "ቅዲ ኣኒሜሽን",
    label_background_color: "ሕብሪ ድሕረ ባይታ",
    label_interval: "ፍልልይ",
    tool_anim_config: "ኣኒሜሽን ውቅር",
    label_new_width: "ሓድሽ ስፍሓት",
    label_new_height: "ሓድሽ ቁመት",
    label_apply: "ኣተግብር",
    label_colors: "ሕብርታት",
    label_size: "ግዝፊ",
    label_tolerance: "ምክእኣል",
    val_horizontal: "ንጋድም",
    val_vertical: "ንትኹል",
    val_sequence: "ቕደም ስዓብ",
    val_bounce: "ምንጣር",
    val_random: "ሓንደበት",
    val_solid: "ደረቕ",
    val_clear: "ንፁር",
    action_add_sheet: "ሓድሽ ወረቐት",
    action_import: "ናብ ዓዲ ውሽጢ ኣቕሓ ምእታው",
    action_export: "ናብ ደገ ምልኣኽ",
    action_sort_projects: "ምስራዕ",
    sort_date_old: "ዝዓበየ ቀዳማይ",
    sort_date_new: "ሓድሽ ቀዳማይ",
    sort_name_az: "ስም (A-Z)",
    sort_name_za: "ስም (Z-A)",
    action_new_sprite: "ሓድሽ ስፕራይት።",
    action_new_project: "ሓድሽ ፕሮጀክት",
    modal_save_all_title: "ኩሉ ለውጢ ኣቐምጦ",
    modal_save_all_desc: "ክትዕቅቦም እትደሊ ንብረት ምረጽ፤",
    modal_save_selected: "ምዕቃብ ዝተመርጸ",
    action_saved: "ተዓቂቡ ኣሎ።",
    modal_create_sprite_title: "ሓድሽ ስፕራይት ምፍጣር",
    modal_create_project_title: "ሓድሽ ፕሮጀክት ምፍጣር",
    modal_add_sheet_title: "ሓድሽ ወረቐት ምውሳኽ",
    modal_rename_sheet_title: "ንሸት ዳግማይ ስም ምሃብ",
    modal_rename_sprite_title: "ስፕራይት ዝብል ስም ምቕያር",
    modal_delete_sprite_title: "ስፕራይት ምድምሳስ",
    modal_delete_project_title: "ፕሮጀክት ምድምሳስ",
    modal_delete_sheet_title: "ሸት ምድምሳስ",
    placeholder_sprite_name: "ሽም",
    placeholder_project_name: "ሽም",
    placeholder_sheet_name: "ሽም",
    placeholder_new_name: "ሓድሽ ስም",
    action_create: "ፍጠር",
    action_add: "ምድማር",
    action_rename: "ዳግማይ ስም ምቕያር",
    action_duplicate: "ድፕሊኬት ምግባር",
    action_delete: "ምድምሳስ",
    action_cancel: "ሰርዝ",
    confirm_delete_sprite: "ነዚ ስፕራይት ክትድምስሶ ከም እትደሊ ርግጸኛ ዲኻ?",
    confirm_delete_project: "ነዚ ፕሮጀክት ክትድምስሶ ከም እትደሊ ርግጸኛ ዲኻ? ኩሎም ስፕራይት ክእለዩ እዮም።",
    confirm_delete_sheet: "ነዚ ወረቐት ክትድምስሶ ከም እትደሊ ርግጸኛ ዲኻ?",
    err_select_sprite: "በጃኹም መጀመርታ ስፕራይት ምረጹ።",
    err_select_project: "በጃኹም መጀመርታ ሓደ ፕሮጀክት ምረጹ።",
    err_name_empty: "ስም ባዶ ክኸውን ኣይክእልን እዩ።",
    err_sprite_exists: "በዚ ስም እዚ ዘለዎ ስፕራይት ድሮ ኣሎ።",
    err_project_exists: "በዚ ስም ዘለዎ ፕሮጀክት ድሮ ኣሎ።",
    err_no_content: "ክትዕቅቦ እትኽእል ትሕዝቶ የለን።",
    err_no_changes: "ንምዕቃብ ዝኾነ ለውጢ የለን።",
    err_delete_last_sheet: "ናይ መወዳእታ ወረቐት ክስረዝ ኣይክእልን እዩ።",
    err_extract_frames: "ዝኾነ ፍሬም ከውጽእ ኣይከኣለን።",
    err_indexeddb: "ኣብ ውሽጢ ዓዲ ምዕቃብ ኣይከኣለን። መርበብ ሓበሬታኻ IndexedDB ክድግፍ ኣይክእልን እዩ።",
    msg_upload_success: "ምጽዓን ዕዉት: {0}",
    msg_upload_failed: "ምጽዓን ኣይተዓወተን: {0}",
    msg_save_success: "ዕዉት ዕቅብ።",
    msg_saving: "ዕቋር...",
    msg_multi_save_result: "ዝተዓቀበ {0} ንብረት። {1} ውድቀት።",
    menu_title: "ዝርዝር መግቢ",
    menu_save: "ምቑጣብ",
    menu_save_all: "ኩሉ ኣድሕን",
    menu_support: "ንደገፍ ርክብ ግበሩ",
    label_local_storage: "ናይ ከባቢ መኽዘን",
    label_sign_in: "Sign In",
    modal_export_title: "ስፕራይት ሰደድ",
    label_filename: "ስም ፋይል",
    label_format: "ቅርጺ",
    action_export_confirm: "ናብ ደገ ምልኣኽ",
};

export default translations;
